// Maiuscole italiane (stesse regole del backend formato.py) e applicazione automatica all'uscita dal campo.
const PARTICELLE = new Set(["de", "di", "da", "del", "della", "dello", "dei", "degli", "delle", "dal", "dalla", "lo", "la", "li", "le", "van", "von", "mc", "mac"]);
const MINUSCOLE = new Set(["di", "de", "del", "della", "delle", "dello", "dei", "degli", "da", "dal", "dalla", "dalle", "nel", "nella", "nelle", "sul", "sulla",
  "e", "ed", "in", "a", "al", "alla", "alle", "ai", "agli", "per", "con", "tra", "fra", "su", "sotto", "il", "lo", "la", "i", "gli", "le"]);
const APO_MIN = new Set(["d", "nell", "dell", "all", "sull", "dall", "l", "un"]);
const ROMANI = /^(?=[ivxlcdm]+$)m{0,3}(cm|cd|d?c{0,3})(xc|xl|l?x{0,3})(ix|iv|v?i{0,3})$/i;
const NO_ROMANI = new Set([...PARTICELLE, "mi", "vi", "ci", "mix", "dc", "cc", "mm"]);
const cap = (w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w);

function parola(w, luogo, interna) {
  if (!w || !/[a-zà-ÿ]/i.test(w)) return w;
  if (w.includes("-")) return w.split("-").map((p) => parola(p, luogo, false)).join("-");
  const x = w.replace("’", "'");
  if (x.includes("'")) {
    const [a, ...b] = x.split("'");
    return `${luogo && interna && APO_MIN.has(a.toLowerCase()) ? a.toLowerCase() : cap(a)}'${cap(b.join("'"))}`;
  }
  if (luogo && interna && MINUSCOLE.has(w.toLowerCase())) return w.toLowerCase();
  if (luogo && ROMANI.test(w) && w.length > 1 && !NO_ROMANI.has(w.toLowerCase())) return w.toUpperCase();
  return cap(w);
}

export function titolo(s, luogo = false) {
  if (typeof s !== "string" || !s.trim()) return s;
  return s.trim().split(/\s+/).map((w, i) => parola(w, luogo, i > 0)).join(" ");
}

const ESCLUDI = /(societa|ragione|forn|titolo|descr|note|password|cerca|search|query|filtro|cat-nome|modello|voce|task|riunion|campagn|gruppo|msg|evento|cartella|team|template|commento|oggetto|testo|messaggio|file|brand|serie|premio|obiettiv)/i;
const tipo = (id) => {
  if (!id || ESCLUDI.test(id)) return null;
  const k = id.toLowerCase().replace(/_/g, "-");
  if (/(^|-)(email|pec)$/.test(k)) return "lower";
  if (/(^|-)(codice-fiscale|cf|partita-iva|piva|provincia|categoria-catastale)$/.test(k)) return "upper";
  if (/(^|-)(indirizzo|via|via-immobile|res-via|comune|res-comune|citta|zona|quartiere|frazione|luogo-nascita|luogo|localita)$/.test(k)) return "luogo";
  if (/(^|-)(nome|cognome|proprietario-nome|proprietario-cognome|contatto-nome|name)$/.test(k)) return "persona";
  return null;
};

export function installaMaiuscole() {
  const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  document.addEventListener("focusout", (e) => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement) || !["text", "email", "search", ""].includes(el.type) || el.readOnly || el.disabled) return;
    const t = tipo(el.getAttribute("data-testid") || el.name || el.id);
    if (!t || !el.value) return;
    const v = t === "lower" ? el.value.trim().toLowerCase() : t === "upper" ? el.value.trim().toUpperCase() : titolo(el.value, t === "luogo");
    if (v !== el.value) { setter.call(el, v); el.dispatchEvent(new Event("input", { bubbles: true })); }
  }, true);
}
